<template>
  <div class="main-view new-mian-ui">
    <!-- 选择展会 -->
    <div class="new-mian-ui-exhibition">
      <div class="new-mian-ui-exhibition-box">
        <span class="new-mian-ui-exhibition-box-exhibitionName">{{ (isEn && exhibitionNameEn && exhibitionNameEn !== 'undefined') ? exhibitionNameEn : exhibitionName }}</span>
        <span v-if="isShowSwitchExhibition" class="new-mian-ui-exhibition-box-btn click" @click="changeExhibition">
          <a-icon type="swap" />
          {{ $t("main.btn_switch_expo") }}
        </span>
      </div>
    </div>

    <!--banner start-->
    <div id="banners" class="banners">
      <a-carousel autoplay arrows>
        <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <!-- 有 banner 数据 -->
        <template v-if="banners.length > 0">
          <div v-for="(item, index) in banners" :key="index">
            <img :src=" severUrl + '/a/api/home/downloadByType?id=' + item.imageId + '&isThumball=true&srcType=bannerImg' " class="banner-imgs">
          </div>
        </template>
        <!-- 无 banner 数据，用默认图 -->
        <template v-else>
          <template v-if="envConfig.envName === 'poly'">
            <div v-for="(item, index) in polyBanners" :key="index">
              <img :src="item.url" class="banner-imgs">
            </div>
          </template>
          <template v-else-if="envConfig.envName === 'baima'">
            <div v-for="(item, index) in baimaBanners" :key="index">
              <img :src="item.url" class="banner-imgs">
            </div>
          </template>
          <template v-else-if="envConfig.envName === 'wzicec'">
            <div v-for="(item, index) in wzicecBanners" :key="index">
              <img :src="item.url" class="banner-imgs">
            </div>
          </template>
          <template v-else>
            <div v-for="(item, index) in defaultBanners" :key="index">
              <img :src="item.url" class="banner-imgs">
            </div>
          </template>
        </template>

      </a-carousel>
    </div>

    <div class="new-mian-ui-contain">
      <!-- 展会公告 -->
      <div
        v-if="notices.length > 0"
        class="new-mian-ui-contain-notice"
      >
        <div class="new-mian-ui-contain-notice-icon">
          <img src="static/imgs/home_ic_zhgg.png">
          {{ $t("main.展会公告") }}
        </div>
        <div class="new-mian-ui-contain-notice-con">
          <a-carousel
            ref="carousel"
            :dots="false"
            dot-position="right"
            autoplay
          >
            <div
              v-for="(item, key) in notices"
              :key="key"
              :title="item.showContent"
              class="new-mian-ui-contain-notice-con-carousel txtOverflow click"
              @click="noticeDetail(item.id)"
            >
              {{ item.showContent }}
            </div>
          </a-carousel>
        </div>
        <div
          class="new-mian-ui-contain-notice-more click"
          @click="$router.push('/notice/list')"
        >
          {{ $t("main.查看更多") }}
          &gt;
        </div>
      </div>
      <!-- 功能服务 -->
      <div class="new-mian-ui-contain-server">
        <div
          v-for="(item, index) in tabsfuns"
          :key="index"
          class="new-mian-ui-contain-server-box flex click"
          @click="goToPage(item.configValue,item.attribute)"
        >
          <img :src="item.imageId">
          <div class="new-mian-ui-contain-server-box-rightBox">
            <div
              :class="{ enStyle: isEn }"
              class="new-mian-ui-contain-server-box-rightBox-title"
            >
              {{ item.configName | dataI18n(lang) }}
            </div>
            <div
              :class="{ enStyle: isEn }"
              class="new-mian-ui-contain-server-box-rightBox-dec"
            >
              {{ item.remarks | dataI18n(lang) }}
            </div>
          </div>
        </div>
      </div>
      <!-- 展会时间安排 -->
      <div class="new-mian-ui-contain-exTime">
        <div class="new-mian-ui-contain-exTime-title verticalLine">
          {{ $t("main.schedule") }}
        </div>
        <div v-if="timeList.length > 0" class="new-mian-ui-contain-exTime-showBox flex">
          <a-icon
            :class="{ disabled: offset == 0 }"
            class="new-mian-ui-contain-exTime-showBox-leftArrow click arrow"
            type="left"
            @click="translateXTimeBox(1, offset == 0)"
          />
          <div class="new-mian-ui-contain-exTime-showBox-containBox">
            <div :style="translateBox" class="new-mian-ui-contain-exTime-showBox-containBox-translateBox flex">
              <div
                v-for="(item, key) in timeList"
                :key="key"
                :class="{ active: key == activeTimeBox }"
                class="new-mian-ui-contain-exTime-showBox-containBox-translateBox-detailBox"
              >
                <div :title="item.name | dataI18n(lang)" class="txtOverflow new-mian-ui-contain-exTime-showBox-containBox-translateBox-detailBox-title">
                  {{ item.name | dataI18n(lang) }}
                </div>
                <div class="new-mian-ui-contain-exTime-showBox-containBox-translateBox-detailBox-con">
                  <div :class="{ txtLeft: !item.startTime }" class="new-mian-ui-contain-exTime-showBox-containBox-translateBox-detailBox-con-startTime">
                    {{ $t("main.从") }} {{ item.startTime | txtilter }}
                  </div>
                  <div :class="{ txtLeft: !item.endTime }" class="new-mian-ui-contain-exTime-showBox-containBox-translateBox-detailBox-con-endTime">
                    {{ $t("main.至") }} {{ item.endTime | txtilter }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-icon
            :class="{ disabled: maxBox - timeList.length >= offset }"
            class="new-mian-ui-contain-exTime-showBox-rightArrow click arrow"
            type="right"
            @click="translateXTimeBox(-1, maxBox - timeList.length >= offset)"
          />
        </div>
        <div v-else class="new-mian-ui-contain-exTime-noData">
          {{ $t("main.当前展会暂未公布时间安排") }}
        </div>
      </div>
      <!-- 主场人员 -->
      <div v-if="contactInfo.length > 0" class="new-mian-ui-contain-contacts">
        <div class="new-mian-ui-contain-contacts-title verticalLine">
          {{ $t("main.contact_info") }}
        </div>
        <div class="new-mian-ui-contain-contacts-contain flex">
          <div
            v-for="(item, key) in contactInfo"
            :key="key"
            class="new-mian-ui-contain-contacts-contain-box"
          >
            <div class="new-mian-ui-contain-contacts-contain-box-title">
              {{ (isEn && item.departmentEn) ? item.departmentEn : item.department }}
            </div>
            <div
              :title="(isEn && item.positionExplainsEn) ? item.positionExplainsEn : item.positionExplains"
              class="new-mian-ui-contain-contacts-contain-box-subTitle txtOverflow"
              v-html="(isEn && item.positionExplainsEn) ? item.positionExplainsEn : item.positionExplains"
            />
            <div class="new-mian-ui-contain-contacts-contain-box-Contacts">
              <div
                :title="(isEn && item.nameEn) ? item.nameEn : item.name"
                class="new-mian-ui-contain-contacts-contain-box-Contacts-name txtOverflow"
                v-html="(isEn && item.nameEn) ? item.nameEn : item.name"
              />
              <div
                v-if="item.telephone"
                class="new-mian-ui-contain-contacts-contain-box-Contacts-telephone"
                v-html="item.telephone"
              />
              <div
                v-if="item.phone"
                class="new-mian-ui-contain-contacts-contain-box-Contacts-phone"
                v-html="item.phone"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 资料下载 -->
      <div class="new-mian-ui-contain-download">
        <div class="new-mian-ui-contain-download-title verticalLine">
          {{ $t("main.download_info") }}
        </div>
        <div v-if="manualFile.length > 0" class="new-mian-ui-contain-download-contain">
          <a-checkbox-group v-model="fileDataIdList">
            <div
              :class="{ downloadvVerticalLine: manualFile.length > 1 }"
              class="new-mian-ui-contain-download-contain-list flex"
            >
              <div
                v-for="(item, index) in manualFile"
                :key="index"
                class="new-mian-ui-contain-download-contain-list-item"
              >
                <a-checkbox :value="item.dataId">&nbsp;&nbsp;{{ item.name }}</a-checkbox>
              </div>
            </div>
          </a-checkbox-group>
          <div class="new-mian-ui-contain-download-contain-downloadBtn">
            <a-button type="primary" @click="showdownView">
              {{ $t("main.download") }}
            </a-button>
          </div>
        </div>
        <div v-else class="new-mian-ui-contain-download-noFile">
          <div>
            <img src="static/kong.png">
          </div>
          <div class="common-font">{{ $t("main.miss_downlaodData_msg") }}</div>
        </div>
      </div>
    </div>

    <!--导航条start 客服-->
    <div class="floatview">
      <template v-if="envConfig.showKeFu">
        <div v-if="envConfig.envName !== 'baima'" class="imgview">
          <a :href="root.kefu_qq_url" target="_black">
            <div class="imgviewo-bg">
              <a-icon style="font-size:20px;" type="qq" />
            </div>
            {{ $t("main.dock_customer_service") }}
          </a>
        </div>
        <div class="imgview" @click="showModal">
          <a :href="feedbackUrl" target="_blank">
            <div class="imgviewt-bg">
              <a-icon style="font-size:20px;" type="edit" />
            </div>
            {{ $t("main.dock_feedback") }}
          </a>
        </div>
      </template>
      <div class="imgview">
        <a href="#">
          <div class="imgviewtt-bg">
            <a-icon style="font-size:20px;" type="arrow-up" />
          </div>
          {{ $t("main.dock_top") }}
        </a>
      </div>
    </div>
    <!--导航条end-->

    <!--意见反馈start-->
    <a-modal
      :title="$t('main.feedback_title')"
      :visible="visible"
      :width="600"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div>
        <div class="edit_container option-view">
          <quill-editor
            ref="myQuillEditor"
            v-model="feedbackContent"
            :options="editorOption"
            :aria-placeholder="$t('main.feedback_placeholder')"
            style="height:200px;"
          />
        </div>
      </div>
    </a-modal>
    <!--意见反馈end-->

    <!--展会选择start-->
    <a-modal
      v-model="exhibitionView"
      :mask-closable="false"
      :keyboard="false"
      :closable="true"
      :footer="null"
      :width="1200"
    >
      <div style="height:680px;">
        <div class="exhibitionName-top">
          <div class="exhibitionName-input">
            <a-form layout="vertical">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item
                    :label="$t('main.expo_name_input')"
                    style="margin-bottom:0px;padding-bottom:0px"
                  >
                    <a-input
                      v-model="exhibitionSelectInput"
                      :placeholder="$t('main.expo_name_input_palceholder')"
                      :max-length="150"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item
                    :label="$t('main.expo_start_time_input')"
                    style="margin-bottom:0px;padding-bottom:0px"
                    has-feedback
                  >
                    <a-month-picker
                      :placeholder="
                        $t('main.expo_start_time_input_placeholder')
                      "
                      style="width:100%"
                      @change="selectByTime"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </div>
        </div>

        <div class="exhibition-opera">
          <span class="tip-text">
            温馨提示：如以下列表未找到您相匹配的展会，说明主场尚未将贵公司设置为该展会特装搭建商,请与主场联系！或点击按钮
          </span>

          <a-button v-if="showApplyBtn" type="primary" @click="openApplySpecial">申请成为特装搭建商</a-button>
        </div>

        <div class="exhibitionList">
          <div
            v-for="(item, index) in exhibitionList"
            :key="index"
          >
            <div class="exhibition-time-tile">{{ item.dates }}</div>
            <div
              v-for="(expo, index1) in item.list"
              :key="index1"
            >
              <div
                class="exhibition-bodys"
                @click="selectExhibition(expo.exhibitionId, expo.exhibitionName, expo.exhibitionNameEn)"
              >
                <div class="exhibition-bodys-left">
                  <!-- <ems-img
                    v-if="expo.logoId"
                    class="exhibition-bodys-left-img"
                    :src="expo.logoPath"
                  /> -->
                  <img
                    v-if="expo.logoId"
                    :src="(isEn && expo.logoPathEn) ? expo.logoPathEn : expo.logoPath"
                    class="exhibition-bodys-left-img"
                  >
                  <img
                    v-else
                    class="exhibition-bodys-left-img"
                    src="static/img_zhmr.png"
                    alt=""
                  >
                </div>

                <div class="exhibition-bodys-center">
                  <div class="exhibition-bodys-center-title">
                    <div v-if="expo.exhibitionStatus === '已结束'" class="exhibition-status-tag">
                      已结束
                    </div>
                    <div
                      v-html="(isEn && expo.exhibitionNameEn) ? expo.exhibitionNameEn : expo.exhibitionName"
                    />
                  </div>
                  <div class="exhibition-bodys-center-time">
                    <span class="time">{{ expo.openexTime }}-{{ expo.evacuteTime }}</span>
                    <span>主场名称:{{ expo.homeContractor }}</span>
                    <div class="area">负责区域:
                      <a-popover title="负责区域">
                        <template slot="content">
                          <p>{{ expo.hall || '-' }}</p>
                        </template>
                        <span>
                          {{ expo.hall || '-' }}
                        </span>
                      </a-popover>
                    </div>
                  </div>
                </div>

                <div class="exhibition-bodys-right">
                  <a-icon
                    type="right"
                    style="color:#CECECE;"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="exbitionview-bottom">
          {{ $t("main.change_expo_tips") }}
          <router-link to="/order?type=ordinary">{{
            $t("main.change_expo_tips_link")
          }}</router-link>
        </div>
      </div>
    </a-modal>
    <!--展会选择end-->
    <!--补充资料start-->
    <a-modal
      :title="$t('main.userinfo_title')"
      :visible="userinfo_visible"
      :mask-closable="false"
      :z-index="999999"
      :keyboard="false"
      :closable="false"
      :footer="null"
    >
      <div class>
        <a-form
          :form="userInfo_form"
          @submit="saveUserInfo"
        >
          <a-form-item
            :label="$t('main.userinfo_userName')"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-input
              v-decorator="[
                'userinfo_userName',
                {
                  initialValue: userInfo.name,
                  rules: [
                    { required: true, message: $t('main.userinfo_msg_name') }
                  ]
                }
              ]"
              :max-length="150"
            />
          </a-form-item>
          <a-form-item
            :label="$t('main.userinfo_phone')"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-input
              v-decorator="[
                'userinfo_phone',
                {
                  initialValue: userInfo.mobile,
                  rules: [
                    {
                      required: true,
                      message: $t('main.userinfo_msg_phone'),
                      pattern: phoneRegExp
                    }
                  ]
                }
              ]"
              :max-length="150"
            />
          </a-form-item>
          <a-form-item
            :label="$t('main.userinfo_verification_code')"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 10 }"
            :validate-status="status_verification"
            :help="custom_mes_verification"
            has-feedback
          >
            <a-input
              v-decorator="[
                'userinfo_verification_code',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('main.userinfo_msg_verification')
                    }
                  ]
                }
              ]"
              class="verification_code_input"
              :max-length="150"
              @blur="verifgyCode()"
            />
            <a-button
              v-if="!isGetCode"
              :disabled="
                typeof userInfo_form.getFieldError('userinfo_phone') !=
                  'undefined'
              "
              type="primary"
              class="verification_code_btn"
              @click="sendCode"
            >{{ $t("login.get_code_btn") }}</a-button>
            <a-button
              v-if="isGetCode"
              class="middle verification_code_btn"
            >{{ pwdCount }}{{ $t("login.got_code_btn") }}</a-button>
          </a-form-item>

          <a-form-item
            :label="$t('main.userinfo_email')"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-input
              v-decorator="[
                'userinfo_email',
                {
                  initialValue: userInfo.email,
                  rules: [
                    {
                      required: true,
                      message: $t('main.userinfo_msg_email'),
                      pattern: emailRegExp
                    }
                  ]
                }
              ]"
              :max-length="150"
            />
          </a-form-item>
          <div style="text-align: center;">
            <a-button
              type="primary"
              @click="saveUserInfo()"
            >{{
              $t("main.userinfo_btn")
            }}</a-button>
          </div>
        </a-form>
      </div>
    </a-modal>
    <!--补充资料end-->
    <!-- 发票同意协议-->
    <a-modal
      v-model="isAgreeInvoice"
      :mask-closable="true"
      :footer="null"
      :width="800"
      title="请仔细阅读以下条款"
    >
      <div v-if="envConfig.envName === 'ningbo'">
        <p>
          1.搭建商与参展商一定要在系统申请时确认好需要我公司开具的发票内容
        </p>
        <p>
          2.我公司开出的发票统一为电子发票（增值税 <span class="theme-color">专用</span> 发票或增值税 <span class="theme-color">普通</span> 发票），请在线上事先准备无误的登记好开票资料后，我公司将在<span class="theme-color">1个星期</span>内开出并以电子邮箱形式发送给申请人填写邮箱
        </p>
        <p>
          3.以下费用由我公司提供发票：
          <span class="theme-color">水、电、气费、管理费、审图费、展具租赁费、施工证、加班费</span>，此费用在我公司开具发票
        </p>
        <p>
          4.认真核对开票名称、金额是否正确，如发现错误请及时与主场相关人员联系
        </p>
        <p>
          5.开票内容：
          <span class="theme-color">*会展服务*展览服务费</span>
        </p>
      </div>
      <div v-else>
        <p>
          1.搭建商与参展商一定要在布展期间在线上确认好需要我公司开具的发票内容
        </p>
        <p>
          2.我公司开出的发票统一为二联《增值税
          <span class="theme-color">普通</span> 发票》如需开具三联《增值税
          <span class="theme-color">专用</span>发票》请在线上事先准确无误的登记好开票资料后，我公司将于
          <span class="theme-color">1-2个月</span>后开出快递给到贵公司
        </p>
        <p>
          3.各项费用合计
          <span class="theme-color">低于1000元以下</span>的，我公司只开具《电子普通发票》，不提供《增值税专用发票》
        </p>
        <p>
          4.一个公司发票抬头只开具
          <span class="theme-color">一张</span>发票，请在
          <span class="theme-color">同一时段</span>提交发票申请，以便我司进行开票金额的合并。
        </p>
        <p>
          5.以下费用由我公司提供发票：
          <span class="theme-color">水、电、气费、管理费、审图费、展具租赁费、施工证、加班费</span>，此费用在我公司开具发票
        </p>
        <p>
          6.认真核对开票名称、金额是否正确，如发现错误请及时与主场相关人员联系
        </p>
        <p>
          7.开票内容：
          <span class="theme-color">*会展服务*展览服务费</span>
        </p>
      </div>
      <div style="text-align:right">
        <a-button
          type="primary"
          @click="$router.push({ path: '/invoiceIndex' })"
        >同意</a-button>
        <a-button @click="isAgreeInvoice = false">取消</a-button>
      </div>
    </a-modal>
    <a-modal
      v-model="insuranceVisible"
      :mask-closable="true"
      :footer="null"
      :width="800"
      title="注意事项"
    >
      <div>
        <p>1、购买保险请仔细填写正确的展位号和展会信息;</p>
        <p>2、购买保险务必仔细阅读保险条款和投保须知;</p>
        <p>3、目前仅支持购买展会保（展览会责任险）;</p>
        <p>4、一次下单仅支持用一个公司购买保险;</p>
        <p>
          5、请务必保证填写信息的真实性和准确性，如因信息填写有误造成的后果由客户自行承担。
        </p>
        <p>
          6、通过本平台购买保险的用户，如遇展会延期情况，请在<span style="color: #d10100;">保险生效前3个工作日内</span>通知工作人员，联系保险公司办理保险日期变更事项，如未及时通知导致超出保单保险期间，保单失效的，将无法对保单做出变更，敬请谅解。
        </p>
      </div>
      <div style="text-align:right">
        <a-button
          type="primary"
          @click="toInsurance"
        >立即投保</a-button>
        <a-button @click="insuranceVisible = false">取消</a-button>
      </div>
    </a-modal>
    <a-modal
      v-model="insuranceCodeUrlVisible"
      :mask-closable="true"
      :footer="null"
      :width="400"
      title="保险购买"
    >
      <div class="center">
        <div style="font-weight:bold">手机扫码下方二维码购买保险</div>
        <canvas id="codeURL" />
      </div>
    </a-modal>
    <a-modal
      v-model="popNoticesVisible"
      :title="popupNoticeDetail.title"
      :closable="false"
      :mask-closable="false"
      :footer="null"
      :width="800"
    >
      <div>
        <p v-html="popupNoticeDetail.content" />
        <p class="popNotice-time">{{ popupNoticeDetail.createDate }}</p>
      </div>
      <div style="text-align:right">
        <a-button
          :loading="popNoticeLoading"
          type="primary"
          @click="beforeReadNotice"
        >{{ $t("index.confirm_btn") }}</a-button>
      </div>
    </a-modal>

    <!-- 企业认证弹窗 -->
    <a-modal
      v-model="certification_visible"
      :destroy-on-close="true"
      :mask-closable="false"
      :footer="null"
      width="420px"
      :z-index="99999"
      @ok="closeModal"
    >
      <div class="dialog" style="text-align:center;">
        <div class="title" style="font-size:18px;">
          <a-icon type="info-circle" theme="filled" style="color:#e6a23c;" />
          <span style="font-weight:bold;">提示</span>
        </div>
        <div style="margin-top:10px; margin-bottom:20px;">
          请先完成企业认证
        </div>
        <div class="foot">
          <a-button @click="certification_visible = false">取消</a-button>
          <a-button type="primary" @click="$router.push('/EnterpriseCertification')">企业认证</a-button>
        </div>
      </div>
    </a-modal>

    <!-- 电力展会电力接驳 -->
    <a-modal
      :visible="powerVisible"
      :footer="null"
      @ok="powerVisible = false"
      @cancel="powerVisible = false"
    >
      <template>
        <div class="dxModal">
          <div class="title">展会电力接驳</div>
          <div class="flex">
            <p>
              申请用电安装、送电、检修、延迟断电等服务请联系主场工作人员或扫描下方二维码，进入小程序
            </p>
            <img src="/static/imgs/home_ic_dx.png" alt="">
          </div>
        </div>
        <div class="footer">
          <img width="150px" src="https://asset.zzxes.com.cn/wechatApplet/ems-pc-ui/electric-miniprogram.jpg" alt="">
        </div>
      </template>
    </a-modal>

    <!-- 申请成为特装搭建商 -->
    <a-modal
      :visible="specialVisible"
      title="申请成为特装搭建商 - 选择展会"
      width="1000px"
      :footer="null"
      @ok="specialVisible = false"
      @cancel="specialVisible = false"
    >
      <div>
        <a-form layout="inline">
          <div class="special-form">
            <a-form-item
              label="展会名称"
              style="margin-bottom:0px;padding-bottom:0px"
            >
              <a-input
                v-model="specialForm.exhibitionName"
                placeholder="请输入展会名称"
                :max-length="150"
              />
            </a-form-item>

            <a-button @click="resetSearch">重置</a-button>
            <a-button type="primary" @click="getExhibitionPageData">查询</a-button>
          </div>
        </a-form>

        <div style="max-height: 600px;overflow: auto;margin-top: 10px;">
          <TablePager
            :table-data="specialTableData"
            :total="specialTotal"
            :is-scroll="{}"
            :page-num="specialPage.current"
            border
            @changePagination="changePagination"
          >
            <template v-for="item in specialColumns">
              <a-table-column
                v-if="item.scope === 'time'"
                :key="item.key"
                :title="item.title"
                :data-index="item.dataIndex"
                :fixed="item.fixed"
                :width="item.width"
                :custom-render="item.customRender"
              >

                <template slot-scope="text,scope">
                  {{ `${scope.startTime} 至 ${scope.endTime}` }}
                </template>
              </a-table-column>

              <a-table-column
                v-else
                :key="item.key"
                :title="item.title"
                :data-index="item.dataIndex"
                :fixed="item.fixed"
                :width="item.width"
                :custom-render="item.customRender"
              />
            </template>
            <a-table-column
              :width="100"
              title="操作"
              fixed="right"
            >
              <template slot-scope="text,scope">
                <a-button type="link" style="padding:0; height:21px;" @click="apply(scope)">申请加入</a-button>
                <a-button type="link" style="padding:0; height:21px;" @click="viewApply(scope)">我的申请</a-button>
              </template>
            </a-table-column>
          </TablePager>
        </div>

      </div>
    </a-modal>

    <!-- 申请成为特装搭建商 -->
    <a-modal
      :visible="myApplyVisible"
      title="我的申请记录"
      width="1300px"
      :footer="null"
      @ok="myApplyVisible = false"
      @cancel="myApplyVisible = false"
    >
      <div>
        <div style="max-height: 600px;overflow: auto;margin-top: 10px;">
          <TablePager
            :table-data="myApplyTableData"
            :total="myApplyTotal"
            :page-num="myApplyPage.current"
            border
            @changePagination="changeMyApplyPagination"
          >
            <template v-for="item in myApplyColumns">
              <a-table-column
                v-if="item.scope === 'status'"
                :key="item.key"
                :title="item.title"
                :data-index="item.dataIndex"
                :fixed="item.fixed"
                :width="item.width"
                :custom-render="item.customRender"
              >

                <template slot-scope="text,scope">
                  {{ myApplyStatus[scope.status] }}
                </template>
              </a-table-column>

              <a-table-column
                v-else
                :key="item.key"
                :title="item.title"
                :data-index="item.dataIndex"
                :fixed="item.fixed"
                :width="item.width"
                :custom-render="item.customRender"
              />
            </template>
            <a-table-column
              :width="100"
              title="操作"
              fixed="right"
            >
              <template slot-scope="text,scope">
                <a-popconfirm
                  v-if="scope.status === '3'"
                  title="确认重新申请嘛"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="reapply(scope)"
                >
                  <a-button type="link" style="padding:0; height:21px;">重新申请</a-button>
                </a-popconfirm>
              </template>
            </a-table-column>
          </TablePager>
        </div>

      </div>
    </a-modal>

    <!-- 申请加入弹框 -->
    <a-modal
      :visible="applyVisible"
      title="申请成为特装搭建商"
      width="1000px"
      :footer="null"
      @ok="applyVisible = false"
      @cancel="applyVisible = false"
    >
      <div>
        <a-form :form="special_form" layout="horizontal" @submit="submitApply">

          <a-form-item
            label="展会名称"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <span>{{ applyCurrentExhibition.exhibitionName }}</span>
          </a-form-item>

          <a-form-item
            label="主场方"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <span>{{ applyCurrentExhibition.sponsor }}</span>
          </a-form-item>

          <a-form-item
            label="展位号"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'boothNum',
                { rules: [{ required: true, message: '请输入展位号' }] },
              ]"
              placeholder="请输入展位号"
              :max-length="150"
            />
          </a-form-item>

          <a-form-item
            label="参展商名称"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'exhibitor',
                { rules: [{ required: true, message: '请输入参展商名称' }] },
              ]"
              placeholder="请输入参展商名称"
              :max-length="150"
            />
          </a-form-item>

          <a-form-item
            label="搭建商名称"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            {{ userCompanyInfo.companyName }}
          </a-form-item>

          <a-form-item
            label="搭建商联系人"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'contact',
                { rules: [{ required: true, message: '请输入搭建商联系人' }] },
              ]"
              placeholder="请输入搭建商联系人"
              :max-length="150"
            />
          </a-form-item>

          <a-form-item
            label="搭建商联系电话"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'mobilePhone',
                { rules: [{ required: true, message: '请输入搭建商联系电话' }] },
              ]"
              placeholder="请输入搭建商联系电话"
              :max-length="150"
            />
          </a-form-item>

          <a-form-item
            label="搭建商Email"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'email',
                { rules: [{ required: true, message: '请输入搭建商Email' }] },
              ]"
              placeholder="请输入搭建商Email"
              :max-length="150"
            />
          </a-form-item>

          <a-form-item
            label="备注"
            style="margin-bottom:0px;padding-bottom:0px"
          >
            <a-input
              v-decorator="[
                'remark',
              ]"
              placeholder="请输入备注"
              :max-length="150"
            />
          </a-form-item>

          <div style="display: flex; justify-content: center; align-items: center;">
            <a-button type="primary" html-type="submit">提交申请</a-button>
          </div>
        </a-form>
      </div>
    </a-modal>

    <v-Loading :loading="loading" />
  </div>
</template>
<script>
import { envConfig } from '@/common/global'
import LoadingMask from '../../component/LoadingMask'
import { getCookie } from '../../util/util.js'
import TablePager from '@/component/base/TablePager'
import zh from '@/i18n/zh-cn.js'
import en from '@/i18n/en-us.js'
import { phoneRegExp, emailRegExp } from '@/common/regExp.js'
import { defaultBanners, baimaBanners, polyBanners, wzicecBanners } from '@/common/Banner'
import QRCode from 'qrcode'
// import EmsImg from '@/component/base/emsImg.vue'
let validateCode = false
export default {
  inject: ['root'],
  components: {
    'v-Loading': LoadingMask,
    TablePager
    // EmsImg
  },
  filters: {
    txtilter(val) {
      return val || '~'
    }
  },
  data() {
    return {
      polyBanners, baimaBanners, defaultBanners, wzicecBanners,
      phoneRegExp,
      emailRegExp,
      lang: {
        zh: zh.i18nMain,
        en: en.i18nMain
      },
      localeval: sessionStorage.getItem('locale'),
      isAgreeInvoice: false,
      contactNumber: 0,
      loading: false,
      status_verification: '',
      custom_mes_verification: '',
      userinfo_email: '',
      userinfo_verification_code: '',
      userinfo_phone: '',
      userinfo_userName: '',
      tabsIndex: 0,
      tabsfuns: [0, 1, 2, 3, 3, 3],
      labelCol: {
        xs: { span: 74 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      },
      userInfoStatus: true,
      userInfo: {
        name: '',
        mobile: '',
        email: '',
        channel: '',
        refSys: ''
      },
      formLayout: 'inline',
      msg: 'Welcome to Your Vue.js App',
      ModalText: '',
      certification_visible: false,
      userinfo_visible: false,
      visible: false,
      confirmLoading: false,
      exhibitionView: false,
      feedbackContent: '',
      notices: [], // 公告
      popNotices: [], // 弹窗公告
      popNoticeIndex: 0,
      popupNoticeDetail: {},
      popNoticesVisible: false,
      popNoticeLoading: false,
      banners: [], // banner
      severUrl: this.api,
      exhibitionList: [], // 展会列表
      exhibitionListStandby: [], // 备用展会列表（条件选择）
      pwdCount: 60,
      isGetCode: false,
      exhibitionName: '',
      exhibitionNameEn: '',
      insuranceConfig: {}, // 保险配置
      exhibitionId: '',
      exhibitionSelectInput: '',
      exhibitionSelectTime: '',
      contactInfo: [], // 联系人
      timeList: [], // 时间安排列表
      timeSign: 1, // 时间标记
      manualFile: [], // 附件列表
      fileDataIdList: [], // 已选中附件列表
      // normalSelfServices: [], // 标摊功能
      // specialSelfServices: [], // 特装功能
      boothList: [], // 展位列表
      serviceNumber: 0,
      closeLoadIndex: 6,
      isShowSwitchExhibition: true, // 是否显示切换展会，
      excompanyType: '', // 展位类型
      isFrom3rd: false, // 是否第三方同步
      offset: 0, // 展会时间安排偏移量
      activeTimeBox: null, // 当前展会属于哪个期间
      maxBox: 5, // 页面中显示的展会时间安排盒子数
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }]
          ]
        }
      },
      insuranceVisible: false,
      insuranceCodeUrlVisible: false,
      insuranceUrl: '',
      booths: [],
      feedbackUrl: 'https://support.qq.com/products/297738',
      envConfig,
      powerVisible: false,
      /** 用户认证公司信息 */
      userCompanyInfo: {},

      /** 特装搭建商弹框 */
      specialVisible: false,
      /** 特装搭建商表单 */
      specialForm: {
        exhibitionName: ''
      },
      /** 特装搭建商表格数据 */
      specialTableData: [
      ],
      /** 特装搭建商分页 */
      specialPage: {
        size: 10,
        current: 1
      },
      /** 特装搭建商分页总数 */
      specialTotal: 0,

      specialColumns: [
        {
          title: '展会名称',
          dataIndex: 'exhibitionName',
          key: 'exhibitionName',
          width: 200
        },
        {
          title: '展会日期',
          dataIndex: 'endTime',
          key: 'endTime',
          width: 220,
          scope: 'time'
        },
        {
          title: '主办方',
          dataIndex: 'hostName',
          key: 'hostName',
          width: 200
        },
        {
          title: '主场方',
          dataIndex: 'sponsor',
          key: 'sponsor',
          width: 200
        }
      ],

      myApplyVisible: false,
      /** 特装搭建商表格数据 */
      myApplyTableData: [
      ],
      /** 特装搭建商分页 */
      myApplyPage: {
        size: 10,
        current: 1
      },
      /** 特装搭建商分页总数 */
      myApplyTotal: 0,

      myApplyColumns: [
        {
          title: '展会名称',
          dataIndex: 'exhibitionName',
          key: 'exhibitionName'
        },
        {
          title: '主场方',
          dataIndex: 'sponsor',
          key: 'sponsor'
        },
        {
          title: '展位号',
          dataIndex: 'boothNum',
          key: 'boothNum'
        },
        {
          title: '参展商',
          dataIndex: 'exhibitor',
          key: 'exhibitor'
        },
        {
          title: '联系人',
          dataIndex: 'contact',
          key: 'contact'
        },
        {
          title: '电话',
          dataIndex: 'mobilePhone',
          key: 'mobilePhone'
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark'
        },
        {
          title: '审核结果',
          dataIndex: 'status',
          key: 'status',
          scope: 'status'
        },
        {
          title: '审核时间',
          dataIndex: 'auditTime',
          key: 'auditTime'
        },
        {
          title: '审核意见',
          dataIndex: 'reason',
          key: 'reason'
        }
      ],
      myApplyStatus: {
        '1': '待审核',
        '2': '审核通过',
        '3': '审核不通过'
      },
      currentMyApplyOp: {},
      /** 当前申请加入展会信息 */
      applyCurrentExhibition: {},
      applyVisible: false,
      showApplyBtn: false
    }
  },
  computed: {
    isEn() {
      return this.localeval === 'en-us'
    },
    translateBox() {
      // 一个盒子宽200
      const baseBoxWidth = 200
      return `
        width:${baseBoxWidth * this.timeList.length}px;
        transform: translateX(${baseBoxWidth * this.offset}px);
        transition: transform 1s;`
    },
    serviceStyle() {
      let width = 678
      if (this.tabsfuns.length > 4) {
        width += (this.tabsfuns.length - 4) * 169.5
      }
      return `width:${width}px;`
    },
    contactStyle() {
      const left = this.contactNumber * -265
      let width = 1060
      if (this.timeList.length > 4) {
        width += (this.timeList.length - 4) * 265
      }
      return `width:${width}px;left${left}px`
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    timeStyle() {
      let width = 1060
      if (this.timeList.length > 7) {
        width += (this.timeList.length - 7) * 140
      }
      return 'width:' + width + 'px'
    }
  },
  watch: {
    tabsIndex: function(e) {
      this.tabsIndex = e
    },
    exhibitionSelectInput: function(e) {
      this.selectExhibitionByName(e)
    },
    closeLoadIndex: function(e) {
      if (e < 3) {
        this.loading = false
      }
    },
    exhibitionView: function(e) {
      if (!e) {
        return
      }
      // this.$http.get(`${this.HallApi}api/hall/rest/qualification/my`).then(res => {
      //   if (Object.keys(res.data).length === 0) {
      //     console.log('未查询企业认证信息')
      //   } else if (res.data.status === 'IN_REVIEW') {
      //     this.$message.warning('暂时无法申请证件，企业认证资料还在审核中')
      //   } else if (res.data.status === 'REJECT') {
      //     this.$message.warning('企业认证不通过，请至我的企业查看审核结果')
      //   } else if (res.data.remark === 'PENDING') {
      //     if (res.data.auditTag === 1) {
      //       this.$message.warning('当前企业申请中，请至我的企业/我的申请查看审核结果')
      //     } else {
      //       this.$message.warning('当前企业申请未通过，请至我的企业/我的申请查看审核结果')
      //     }
      //   } else {
      //     this.showApplyBtn = true
      //   }
      // }).catch(e => {
      // })
    }
  },
  beforeCreate() {
    this.userInfo_form = this.$form.createForm(this)
    this.special_form = this.$form.createForm(this)
  },
  mounted() {
    if (sessionStorage.getItem('noSwitchExid')) {
      this.isShowSwitchExhibition = false
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    // 首页背景为全白，其他页面背景为灰
    this.root.mainBGC = false
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.root.mainBGC = true

    if (this.$route.query.exhibitionId) {
      this.exhibitionView = false
    }

    // 1.判断是否登录：sessionStorage有user.并校验用户信息完整性
    if (sessionStorage.getItem('user')) {
      // 父级变成登录状态，并赋值
      this.root.isLogin = true
      this.root.userInfo = JSON.parse(sessionStorage.getItem('user'))
      // 校验用户信息完整性
      this.checkUserInfo()
      // 2.判断是否是第三方登录
      this.checkIsFrom3rd()
      // 3.选择展会,在判断第三方登录中调用，不是第三方调用选择展会
    } else {
      const authorization = this.$route.query.Authorization
      if (authorization) {
        sessionStorage.setItem('Authorization', authorization)
        const param = new FormData()
        param.append('Authorization', authorization)
        param.append('mobile', true)
        this.root.ssoLogin(param).then(res => {
          this.root.getUserInfo().then(res => {
            // 校验用户信息完整性
            this.checkUserInfo()
            // 2.判断是否是第三方登录
            this.checkIsFrom3rd()
            // 3.选择展会,在判断第三方登录中调用，不是第三方调用选择展会
          })
        })
      } else {
        // 如果其他地方有登录过就自动帮他登录
        if (getCookie('Authorization') || getCookie('JSESSIONID')) {
          this.root.redirectSSOLogin()
        }
        // 游客选择展会
        this.getExhibition()
      }
    }

    this.initConfig()
  },
  methods: {
    checkCertification(attribute) { // 认证查询
      return new Promise((resolve, reject) => {
        if (attribute && attribute.indexOf('无需企业认证') !== -1) {
          resolve()
          return false
        }
        this.$http.get(`${this.HallApi}api/hall/rest/qualification/my`).then(res => {
          console.log('res.data', res.data)
          if (Object.keys(res.data).length === 0) {
            reject(res)
          } else if (res.data.status === 'IN_REVIEW') {
            this.showConfirm('企业认证已提交，但在审核中，请耐心等待审核结果。', '/personalCenter?type=enterprise', '查看')
          } else if (res.data.status === 'REJECT') {
            this.showConfirm('企业认证不通过，请至我的企业查看审核结果。', '/personalCenter?type=enterprise', '查看')
          } else if (res.data.remark === 'PENDING') {
            if (res.data.auditTag === 1) {
              this.showConfirm(['加入企业申请已提交，请联系公司企业管理员审核,', '可至 “我的企业/我的申请” 查看审核结果。'], '/personalCenter?type=enterprise', '查看', true)
            } else {
              this.showConfirm(['加入企业申请不通过，', '请至 “我的企业/我的申请” 重新申请。'], '/personalCenter?type=enterprise', '去申请')
            }
          } else {
            resolve(res)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    openModal() {
      this.certification_visible = true
    },
    closeModal() {
      this.certification_visible = false
    },
    translateXTimeBox(offset, disabled) {
      if (disabled) {
        return
      }
      // @offset:[-1,0,1,2,3],小于0右移，大于0左移
      // 偏移量为0不能右移，偏移量为limit不能左移
      const limit = this.maxBox - this.timeList.length
      if (
        !(this.offset === 0 && offset > 0) &&
        !(this.offset === limit && offset < 0)
      ) {
        this.offset = this.offset + offset
      }
    },
    getUserInfo() {
      this.userInfo = this.$parent.$parent.userInfo
    },
    goLogin() {
      window.location.href =
        this.ssoUrl +
        'auth/getVerificationToken?tokenUrl=' +
        window.location.href.split('/#/')[0] +
        `/%23/&platformName=${envConfig.platformName}`
    },
    moveService(direction) {
      const isLeft = direction === 'left' ? 1 : -1

      if (isLeft === 1 && this.serviceNumber === 0) {
        return
      }
      if (
        (isLeft === -1 && this.tabsfuns.length - this.serviceNumber === 4) ||
        this.tabsfuns.length <= 4
      ) {
        return
      }
      this.serviceNumber =
        isLeft === 1 ? this.serviceNumber - 1 : this.serviceNumber + 1
      this.$refs.service.style.left = this.serviceNumber * -169.5 + 'px'
    },
    moveContact(direction) {
      const isLeft = direction === 'left' ? 1 : -1

      if (isLeft === 1 && this.contactNumber === 0) {
        return
      }
      if (
        (isLeft === -1 && this.contactInfo.length - this.contactNumber === 4) ||
        this.contactInfo.length <= 4
      ) {
        return
      }
      this.contactNumber =
        isLeft === 1 ? this.contactNumber - 1 : this.contactNumber + 1
      this.$refs.contacts.style.left = this.contactNumber * -265 + 'px'
    },
    // 发送验证码
    sendCode() {
      const vm = this
      var mobile = this.userInfo_form.getFieldValue('userinfo_phone')
      vm.$http({
        method: 'get',
        url: vm.api + 'a/api/user/getverifycodePreCheck?mobile=' + mobile
      }).then(response => {
        if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
          vm.pwdCount = 60
          vm.isGetCode = true
          vm.custom_mes_phone = ''
          vm.countDownFunction()
          vm.$http({
            method: 'get',
            url: vm.api + 'a/api/user/getverifycode?mobile=' + mobile
          }).then(response => {
            vm.$message.success(response.data.data, 8)
          })
        } else {
          vm.$message.error(response.data.message)
        }
      })
    },
    // 校验验证码
    verifgyCode() {
      this.$http({
        method: 'get',
        url:
          this.api +
          'a/api/user/validatemobilecode?mobile=' +
          this.userInfo_form.getFieldValue('userinfo_phone') +
          '&&randomCode=' +
          this.userInfo_form.getFieldValue('userinfo_verification_code')
      }).then(response => {
        if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
          if (response.data.data === false) {
            validateCode = false
            this.status_verification = 'error'
            this.custom_mes_verification = this.$t(
              'main.custom_mes_verification'
            )
          } else {
            validateCode = true
            this.status_verification = 'success'
            this.custom_mes_verification = ''
          }
        }
      })
    },
    saveUserInfo() {
      this.userInfo_form.validateFields((err, values) => {
        if (!err) {
          if (!validateCode) {
            this.status_verification = 'error'
            this.custom_mes_verification = this.$t(
              'main.custom_mes_verification'
            )
            return
          } else {
            this.status_verification = 'success'
            this.custom_mes_verification = ''
          }
          const refSys = this.userInfo.refSys || sessionStorage.getItem('refSys')
          const params = {
            name: values.userinfo_userName,
            mobile: values.userinfo_phone,
            email: values.userinfo_email,
            refSys: refSys
          }
          this.$http({
            method: 'post',
            url: this.api + 'a/api/user/update',
            data: params
          }).then(response => {
            if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
              this.userinfo_visible = false
              this.userInfo.name = values.userinfo_userName
              this.userInfo.mobile = values.userinfo_phone
              this.userInfo.email = values.userinfo_email
              this.root.userInfo = this.userInfo
              sessionStorage.setItem('user', JSON.stringify(this.userInfo))
              this.$message.success(this.$t('main.user_success_update'), 5)
            } else {
              this.$message.error(response.data.message)
            }
          })
        }
      })
    },
    // 获取验证码倒计时
    countDownFunction() {
      var vm = this
      setTimeout(function() {
        vm.pwdCount--
        if (vm.pwdCount > 1) {
          vm.countDownFunction()
        } else {
          vm.isGetCode = false
        }
      }, 1000)
    },

    /**
     * 报图之前的判读
     */
    async beforeGotoDraw() {
      const params = {
        qualificationId: this.userCompanyInfo.id
      }
      return this.$http
        .get(this.api + 'a/api/enterprise/people/selectByQualificationId', { params })
        .then((res) => {
          if (res.data.resultCode === 0 || res.data.resultCode === '0') {
            const personTypeList = res.data.data.map(el => el.personType)
            const message = []
            if (!personTypeList.includes('EL')) {
              message.push('“企业法人”')
            }
            if (!personTypeList.includes('SM')) {
              message.push('“安全负责人”')
            }
            if (!personTypeList.includes('ET')) {
              message.push('“电工”')
            }
            if (message.length) {
              this.showConfirm([`信息待完善，请先至「用户中心-企业人员管理」`, `完善${message.join('、')}信息，才可以正常报图。`], '/personalCenter?type=enterprise&key=personnel', '去完善')
              return false
            }
            return true
          }
        })
        .catch(() => {})
    },
    showConfirm(messages, path, okText, tips) {
      // 判断是否是数组，如果不是则转换为数组
      if (!Array.isArray(messages)) {
        messages = [messages]
      }
      const tipsContent = tips ? <div style='margin-top: 20px'>注：第一个注册搭建商企业账号为企业管理员</div> : ''
      this.$confirm({
        title: this.$t('index.warm'),
        width: 405,
        content: h => (
          <div style='color:#000;'>
            { messages.map(message => <div style='margin-top: 0px;line-height: 28px'>{ message }</div>) }
            {tipsContent}
          </div>
        ),
        okText: okText,
        onOk: () => {
          this.$router.push(path)
        },
        onCancel() {
        }
      })
    },
    async goToPage(configValue, attribute) {
      this.checkCertification(attribute).then(async(res) => {
        const vm = this
        if (configValue === '/electric') {
          this.powerVisible = true
        } else if (configValue === '/drawingsNotice') {
          if (await this.beforeGotoDraw()) {
            vm.$http({
              method: 'get',
              url:
              vm.api +
              'a/api/drawings/isExistCheckDrawing?exhibitionId=' +
              vm.exhibitionId
            }).then(response => {
              if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
                if (response.data.data.existCheckDrawingInfo === true) {
                  vm.$router.push({
                    path: '/drawingsIndex'
                  })
                } else {
                  vm.$router.push({
                    path: '/drawingsNotice'
                  })
                }
              }
            })
          }
        } else if (configValue === '/invoiceIndex') {
          if (vm.userInfo.name === '') {
            vm.root.redirectSSOLogin()
          } else {
            if (envConfig.envName === 'baima') {
              vm.$router.push({ path: '/invoiceIndex' })
            } else {
              vm.isAgreeInvoice = true
            }
          }
        } else if (configValue === '/insuranceHome') {
          // this.insuranceLogin()
          this.toInsurance()
        } else if (configValue === '/Exhibitors') {
          this.$router.push('Exhibitors')
        } else {
          vm.$router.push({
            path: configValue
          })
        }
      })
        .catch(_ => {
          this.openModal()
        })
    },
    insuranceLogin() {
      if (!sessionStorage.getItem('Authorization')) {
        this.root.redirectSSOLogin()
        return
      }
      if (this.insuranceUrl) {
        this.insuranceVisible = true
        return
      }
      this.$http({
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        url: `${this.insuranceApi
        }loginController/mobile/login?Authorization=${sessionStorage.getItem(
          'Authorization'
        )}`
      }).then(res => {
        if (res.data.chinalifeUrl) {
          this.insuranceUrl = res.data.chinalifeUrl
          this.insuranceVisible = true
        } else {
          this.$message.error('展会目前暂不支持购买展览会责任险')
        }
      })
    },

    // 立即投保
    async toInsurance() {
      try {
        const res = await this.getInsuranceConfigInfo()
        this.insuranceConfig = res.data
        if (parseInt(this.insuranceConfig.httpOrigin)) {
          this.insuranceVisible = false
          this.insuranceCodeUrlVisible = true
          this.showInsuranceUrlQrCode()
        } else {
          window.open(this.insuranceConfig.http)
        }
      } catch (err) {
        console.log(err)
      }
      // 弹框或者跳转
    },
    // 获取保险配置信息
    getInsuranceConfigInfo() {
      return this.$http.get(`${this.HallApi}/api/insurance/exhibition/get?exhibitionId=${this.exhibitionId}`)
    },
    // 保险链接二维码
    showInsuranceUrlQrCode() {
      this.$nextTick(() => {
        const canvas = document.getElementById('codeURL')
        QRCode.toCanvas(canvas, this.insuranceConfig.http, function(e) {})
      })
    },
    onEditorReady(editor) {
      // 准备编辑器
    },
    // 切换自定义tab
    // changTab(e) {
    //   this.serviceNumber = 0
    //   if (this.$refs.service !== undefined) {
    //     this.$refs.service.style.left = this.serviceNumber * -169.5 + 'px'
    //   }
    //   this.tabsIndex = e
    //   this.tabsfuns = []
    //   if (e === 0) {
    //     // 光地
    //     this.tabsfuns = this.specialSelfServices
    //   } else if (e === 1) {
    //     // 标准
    //     this.tabsfuns = this.normalSelfServices
    //   } else {
    //     // 自助
    //     this.tabsfuns = [3333, 1, 2]
    //   }
    //   this.tabsfuns.map(i => {
    //     console.log(i.configName)
    //   })
    // },

    callback(key) {
      this.tabsIndex = key
    },
    // 选择资料
    onChangeFile(selectedId) {
      if (this.fileDataIdList.length > 0) {
        let booleanFile = false
        for (var i = 0; i < this.fileDataIdList.length; i++) {
          if (this.fileDataIdList[i].indexOf(selectedId) > -1) {
            this.fileDataIdList.splice(i, 1)
            booleanFile = true
            break
          }
        }
        if (!booleanFile) {
          this.fileDataIdList.push(selectedId)
        }
      } else {
        this.fileDataIdList.push(selectedId)
      }
    },
    // 下载资料
    showdownView() {
      var that = this
      if (that.fileDataIdList.length === 0) {
        that.$message.error(this.$t('main.download_error_tips'))
        return
      }
      let paramEhsAgencyId = ''
      const ehsAgencyId = this.$grooveStore.get('ehsAgencyId') || localStorage.getItem('ehs.agency-id')
      if (ehsAgencyId !== undefined && ehsAgencyId !== '') {
        paramEhsAgencyId = 'paramEhsAgencyId=' + ehsAgencyId // 机构ID
      }
      let src = ''
      if (that.fileDataIdList.length === 1) {
        src =
          that.api +
          'a/api/file/download?dataId=' +
          that.fileDataIdList.toString() +
          '&type=EXHIBITOR_MANUALFILE' +
          '&mobileLogin=true&_ajax=true&JSESSIONID=' +
          getCookie('JSESSIONID')
      } else {
        src = that.api +
          'a/api/file/batchdownload?dataIds=' +
          that.fileDataIdList.toString() +
          '&type=EXHIBITOR_MANUALFILE&&packageName=' +
          that.exhibitionName.replace(/[\\||\/]/g, '_') +
          '&mobileLogin=true&_ajax=true&JSESSIONID=' +
          getCookie('JSESSIONID')
      }
      window.open(src + '&' + paramEhsAgencyId)

      // that.$confirm({
      //   title: this.$t('main.download_confirm'),
      //   onOk () {
      //     let src = ''
      //     if (that.fileDataIdList.length == 1) {
      //       src = that.api +
      //         "a/api/file/download?dataId=" +
      //         that.fileDataIdList.toString() +
      //         "&type=EXHIBITOR_MANUALFILE" +
      //         "&mobileLogin=true&_ajax=true&JSESSIONID=" +
      //         getCookie("JSESSIONID")
      //     } else {
      //       src = that.api +
      //         "a/api/file/batchdownload?dataIds[]=" +
      //         that.fileDataIdList.toString() +
      //         "&type=EXHIBITOR_MANUALFILE&&packageName=" +
      //         that.exhibitionName.replace(/[\\||\/]/g, "_") +
      //         "&mobileLogin=true&_ajax=true&JSESSIONID=" +
      //         getCookie("JSESSIONID")
      //     }
      //     window.open(src)
      //   },
      //   onCancel () { }
      // })
    },
    onEdit(e) { },
    showModal() {
      // this.visible = true
    },
    handleClick(e) { },
    // 去到登录注册页面
    gotoLogin(e) {
      this.$router.push({
        name: 'login',
        query: {
          activeIndex: e
        }
      })
    },
    // 意见反馈
    handleOk(e) {
      if (this.feedbackContent === '') {
        this.$message.error(this.$t('main.feedback_error_tips'))
        return
      }
      const params = new URLSearchParams()
      params.append('contents', this.feedbackContent)
      params.append('sourceType', 'INTERIOR')
      params.append('exhibitionName', this.exhibitionName)
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
      this.$http({
        method: 'post',
        url: this.api + 'a/api/opinioncollect/saveOpinion',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      }).then(response => {
        this.feedbackContent = ''
        this.$message.success(this.$t('main.feedback_success_tips'))
      })
    },
    handleCancel(e) {
      this.visible = false
    },
    gotoBoothDetail(boothId) {
      this.$router.push({ path: '/boothInfo', query: { data: boothId }})
    },
    getBanner() {
      this.$http({
        method: 'post',
        url:
          this.api + 'a/api/home/getBanner?exhibitionId=' + this.exhibitionId,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(res => {
        this.banners = res.data.data
        // 过滤相对应国际化的公告
        if (this.banners.length > 0) {
          this.banners = this.banners.filter(record => !record.il8nScope || record.il8nScope === 'COMMON' || (this.isEn ? record.il8nScope === 'EN' : record.il8nScope === 'CN'))
        }
      })
    },
    // 获取公告、banner
    getNotice() {
      const params = new URLSearchParams()
      const self = this
      self.loading = true
      params.append('exhibitionId', this.exhibitionId)
      this.$http({
        method: 'post',
        url: this.api + 'a/api/home/listNotice',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      })
        .then(response => {
          this.notices = response.data.data
          if (this.notices.length > 0) {
            this.notices = this.notices.filter(record => !record.il8nScope || record.il8nScope === 'COMMON' || (this.isEn ? record.il8nScope === 'EN' : record.il8nScope === 'CN'))
          }
          this.notices.map(item => {
            const div = document.createElement('div')
            div.innerHTML = item.content
            this.replaceImg(div.children)
            this.$nextTick(() => {
              this.$set(
                item,
                'showContent',
                `【${item.title}】 ${div.innerText}`
              )
            })
            if (item.type === 'POP_UP_NOTIFICATION') {
              this.popNotices.push(item)
            }
          })
          this.popNoticeIndex = 0
          this.checkPopNotices()
          self.loading = false
        })
        .catch(erro => {
          self.loading = false
        })
    },
    replaceImg(paretNode) {
      for (let i = 0; i < paretNode.length; i++) {
        const currentNode = paretNode[i]
        if (currentNode.children.length > 0) {
          this.replaceImg(currentNode.children)
        } else {
          if (currentNode.nodeName.toLowerCase().indexOf('img') > -1) {
            currentNode.parentNode.innerHTML = '[图片] '
          } else {
            currentNode.innerText += ' '
          }
        }
      }
    },
    beforeReadNotice() {
      if (this.root.isLogin) {
        this.readNotice()
      } else {
        this.checkPopNotices()
      }
    },
    readNotice() {
      const param = new FormData()
      param.append('srcId', this.popupNoticeDetail.id)
      param.append('srcType', 'NOTIFICATION')
      param.append('exhibitionId', this.exhibitionId)
      param.append('originStatus', '已查阅')
      param.append('modifyStatus', '已查阅')
      this.popNoticeLoading = true
      this.$http({
        method: 'post',
        url: `${this.api}a/api/history/save`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: param
      }).then(res => {
        this.popNoticeLoading = false
        if (res.data.resultCode === 0 || res.data.resultCode === '0') {
          if (res.data.data.length > 0) {
            this.checkPopNotices()
          }
        }
      })
    },
    isReadAllNotice() {
      return new Promise(resolve => {
        this.popNoticesVisible = false
        if (this.popNotices.length > this.popNoticeIndex) {
          this.popupNoticeDetail = this.popNotices[this.popNoticeIndex]
          this.popNoticeIndex++
          resolve()
        }
      })
    },
    checkPopNotices() {
      this.isReadAllNotice().then(() => {
        if (this.root.isLogin) {
          this.$http({
            method: 'get',
            url: `${this.api}a/api/history/list?srcId=${this.popupNoticeDetail.id
            }&createBy.id=${this.userInfo.id}`
          }).then(res => {
            if (res.data.length > 0) {
              this.checkPopNotices()
            } else {
              this.popNoticesVisible = true
            }
          })
        } else {
          this.popNoticesVisible = true
        }
      })
    },
    noticeDetail(noticeId) {
      this.$router.push({
        path: '/notice/detail',
        query: {
          id: noticeId
        }
      })
    },

    // 获取时间安排----------------------------------
    getEventTimes(e) {
      const params = new URLSearchParams()
      const self = this
      self.loading = true
      params.append('exhibitionId', this.exhibitionId)
      this.$http({
        method: 'post',
        url: this.api + 'a/api/home/getEventTimes',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      })
        .then(response => {
          this.closeLoadIndex = --this.closeLoadIndex
          var eventTimes = []
          const eventTypeArray = [
            'ARRANGEEX_TIME',
            'RANT_ENDTIME',
            'OPENEX_TIME',
            'EXHIBITOR_UP',
            'BUILD_UP',
            'EVACUATE_TIME'
          ]
          response.data.data.forEach(element => {
            if (eventTypeArray.indexOf(element.eventType) > -1) {
              eventTimes.push(element)
            }
          })
          this.timeList = this.groupData(eventTimes)
          sessionStorage.setItem('timeList', JSON.stringify(this.timeList))
          // 1.拿到当前时间，判断当前展会在哪个期间
          const nowDate = new Date().valueOf()
          this.timeList.map((item, index) => {
            const startTime = new Date(item.startTime).valueOf()
            const endTime = new Date(item.endTime).valueOf()
            if (startTime <= nowDate && nowDate <= endTime) {
              this.activeTimeBox = index
            }
          })
          // 2.设置偏移量
          const offset =
            this.activeTimeBox + 1 > this.maxBox
              ? this.maxBox - this.activeTimeBox - 1
              : 0
          this.translateXTimeBox(offset)
          // this.getListToList(timeDatas);
        })
        .catch(erro => {
          self.loading = false
        })
    },
    // 获取功能开关----------------------------------
    getServices(e) {
      const params = new URLSearchParams()
      const self = this
      self.loading = true
      params.append('exhibitionId', this.exhibitionId)
      // if (this.excompanyType) {
      //   params.append('excompanyType', Number(this.excompanyType))
      // }
      this.$http({
        method: 'post',
        url: this.api + 'a/api/home/getServices',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      })
        .then(response => {
          this.tabsfuns = this.normalFunction(response.data.data)
          const authMenu = this.tabsfuns.map(item => item.configName)
          sessionStorage.setItem('authMenu', authMenu.join())
          this.$emit('changeMenu', authMenu)
          self.loading = false
        })
        .catch(erro => {
          self.loading = false
        })
    },
    // 获取联系人----------------------------------
    getContactInfos(e) {
      const params = new URLSearchParams()
      const self = this
      self.loading = true
      params.append('exhibitionId', this.exhibitionId)
      this.$http({
        method: 'post',
        url: this.api + 'a/api/home/getContactInfos',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      })
        .then(response => {
          this.closeLoadIndex = --this.closeLoadIndex
          this.contactInfo = response.data.data
        })
        .catch(erro => {
          self.loading = false
        })
    },
    // 获取下载资料----------------------------------
    getManualFiles(e) {
      const params = new URLSearchParams()
      const self = this
      self.loading = true
      params.append('exhibitionId', this.exhibitionId)
      this.$http({
        method: 'post',
        url: this.api + 'a/api/home/getManualFiles',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: params
      })
        .then(response => {
          this.closeLoadIndex = --this.closeLoadIndex
          const files = this.disposeFile(response.data.data)
          this.manualFile = files
        })
        .catch(erro => {
          self.loading = false
        })
    },
    // 标摊功能图标、路由替换
    normalFunction(services) {
      if (services.length > 0) {
        const staticNum = 'static/'
        var imageSrc = staticNum + 'home_ic_mb_nor.png'
        var routerId = ''
        for (var i = 0; i < services.length; i++) {
          if (services[i].configName.indexOf('特装审图') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_tzst.png'
            routerId = '/drawingsNotice'
          } else if (services[i].configName.indexOf('展会费用缴纳') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_fyjn.png'
            routerId = '/booth'
          } else if (services[i].configName.indexOf('租赁服务') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_zlfw.png'
            routerId = '/shopList'
          } else if (services[i].configName.indexOf('押金退款') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_yjtk.png'
            routerId = '/foregift'
          } else if (services[i].configName.indexOf('发票申请') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_fpsq.png'
            routerId = '/invoiceIndex'
          } else if (services[i].configName.indexOf('提交楣板') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_mb.png'
            routerId = '/fasciaList'
          } else if (services[i].configName.indexOf('提交会刊') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_hk.png'
            routerId = '/bookletList'
          } else if (services[i].configName.indexOf('保险购买') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_bx.png'
            routerId = '/insuranceHome'
          } else if (services[i].configName.indexOf('车证') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_cz.png'
            routerId = '/CarLicenseApply/list'
          } else if (services[i].configName.indexOf('施工证') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_sgz.png'
            routerId = '/constructionPermit/list'
          } else if (services[i].configName.indexOf('展位概况') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_zwgk.png'
            routerId = '/booth/boothList'
          } else if (services[i].configName.indexOf('餐饮服务') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_cyfw.png'
            routerId = '/foodList'
          } else if (services[i].configName.indexOf('展会证件申请') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_zjsq.png'
            routerId = '/Exhibitors'
          } else if (services[i].configName.indexOf('展会电力接驳') > -1) {
            imageSrc = staticNum + 'imgs/home_ic_electric.png'
            routerId = '/electric'
          }
          services[i].imageId = imageSrc
          services[i].configValue = routerId
        }
      }

      return services
    },
    // 附件处理
    disposeFile(files) {
      if (files.length > 0) {
        for (var i = 0; i < files.length; i++) {
          const fileName = files[i].name.substring(
            files[i].name.length - 3,
            files[i].name.length
          )
          files[i].subName = fileName
        }
      }
      return files
    },
    // 时间列表
    getListToList(datas) {
      var arrTime = []
      for (var obj in datas) {
        var ov = {}
        if (
          datas[obj].eventName !== undefined ||
          datas[obj].eventTime !== undefined
        ) {
          ov.name = datas[obj].eventName
          ov.time = datas[obj].eventTime
          arrTime.push(ov)
        }
      }
      var thisDate = this.CurentTime()

      for (var i = arrTime.length - 1; i >= 0; i--) {
        if (arrTime[i].time.substring(0, 10) <= thisDate) {
          this.timeSign = i + 1
          break
        }
      }
      this.timeList = arrTime
    },
    // 获取当前时间
    CurentTime() {
      var now = new Date()

      var year = now.getFullYear() // 年
      var month = now.getMonth() + 1 // 月
      var day = now.getDate() // 日
      var clock = year + '.'

      if (month < 10) {
        clock += '0'
      }

      clock += month + '.'

      if (day < 10) {
        clock += '0'
      }

      clock += day + ''

      return clock
    },
    // 时间安排组合
    groupData(timeDatas) {
      var resultData = []
      for (var i = 0; i < timeDatas.length; i++) {
        if (timeDatas[i] !== null && timeDatas[i] !== '') {
          var type = timeDatas[i].eventType
          if (type !== 'CHECK_DRAWINGS_ENDTIME') {
            resultData.push({
              name: timeDatas[i].eventName,
              startTime: timeDatas[i].startTime,
              endTime: timeDatas[i].endTime
            })
          }
        }
      }
      return resultData
    },
    timeText(data) {
      var startDate = ''
      var endDate = ''
      if (data.startTime !== null && data.startTime !== '') {
        startDate = data.startTime.replace(/-/g, '.')
      }
      if (data.endTime !== null && data.endTime !== '') {
        endDate = data.endTime.replace(/-/g, '.')
      }
      if (startDate && endDate) {
        if (startDate.substring(0, 10) === endDate.substring(0, 10)) {
          return (
            startDate.substring(0, 10) +
            ' ' +
            startDate.substring(11, 16) +
            '-' +
            endDate.substring(11, 16)
          )
        } else {
          return (
            startDate.substring(0, 10) +
            '-' +
            endDate.substring(0, 10) +
            ' ' +
            startDate.substring(11, 16) +
            '-' +
            endDate.substring(11, 16)
          )
        }
      } else {
        return startDate.substring(0, 10) + ' ' + startDate.substring(11, 16)
      }
    },
    // 展会名称条件选择
    selectExhibitionByName(e) {
      if (e !== '') {
        const selectName = e
        const slExhibition = []
        for (var i = 0; i < this.exhibitionListStandby.length; i++) {
          var obj = {
            dates: '',
            list: []
          }
          obj.dates = this.exhibitionListStandby[i].dates
          for (var j = 0; j < this.exhibitionListStandby[i].list.length; j++) {
            if (
              this.exhibitionListStandby[i].list[j].exhibitionName.search(
                selectName
              ) !== -1
            ) {
              obj.list.push(this.exhibitionListStandby[i].list[j])
              slExhibition.push(obj)
            }
          }
        }
        this.exhibitionList = new Set(slExhibition)
      } else {
        this.exhibitionList = new Set(this.exhibitionListStandby)
      }
    },
    selectByTime(date, dateString) {
      if (dateString !== '') {
        const selectDate = dateString.replace(/-/g, '年') + '月'
        this.exhibitionSelectTime = selectDate
        const slExhibition = []
        for (var i = 0; i < this.exhibitionListStandby.length; i++) {
          if (selectDate === this.exhibitionListStandby[i].dates) {
            slExhibition.push(this.exhibitionListStandby[i])
          }
        }
        this.exhibitionList = slExhibition
      } else {
        if (this.exhibitionSelectInput !== '') {
          this.selectExhibitionByName(this.exhibitionSelectInput)
        } else {
          this.exhibitionList = this.exhibitionListStandby
        }
      }
    },
    // 切换展会
    changeExhibition(e) {
      this.exhibitionView = true
      this.selectExhibitionList()
    },
    // 选择展会
    selectExhibition(id, name, exhibitionNameEn) {
      this.exhibitionView = false
      this.exhibitionName = name
      this.exhibitionNameEn = exhibitionNameEn || this.exhibitionName
      this.exhibitionId = id
      sessionStorage.setItem('exhibitionId', id)
      sessionStorage.setItem('exhibitionName', name)
      sessionStorage.setItem('exhibitionNameEn', exhibitionNameEn)
      const state = { 'eId': id, 'eName': name, 'exhibitionNameEn': exhibitionNameEn }
      const title = null
      const url = `${location.href}&eId=${id}&eName=${name}&exhibitionNameEn=${exhibitionNameEn}`
      history.pushState(state, title, url)
      if (
        // (this.userInfo.channel === 'MOBILE' || this.userInfo.channel === 'EMAIL') &&
        (this.isEmptyStr(this.userInfo.name) || this.isEmptyStr(this.userInfo.email) || this.isEmptyStr(this.userInfo.mobile))
      ) {
        this.userinfo_visible = true
      }
      this.initData()
    },
    // 展会排序
    sortExhibitionList(list) {
      // console.log(list)
      return list.sort((a, b) => {
        const front = Number(a.dates.replace('年', '').replace('月', ''))
        const behind = Number(b.dates.replace('年', '').replace('月', ''))
        return behind - front
      })
    },

    // 展会列表
    selectExhibitionList(e) {
      this.$http({
        method: 'get',
        url: this.api + `api/user/exhibition/list?companyId=${this.userCompanyInfo.companyId || ''}&exhibitionName=${e || ''}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(response => {
        for (var i = 0; i < response.data.data.length; i++) {
          response.data.data[i].exhibitionStatus = this.getExhibitionStatus(response.data.data[i].openexTime, response.data.data[i].evacuteTime)

          response.data.data[i].openexTime = this.toDate(
            response.data.data[i].openexTime
          )
          response.data.data[i].evacuteTime = this.toDate(
            response.data.data[i].evacuteTime
          )
        }
        var exList = []
        var allExhibition = []
        for (var j = 0; j < response.data.data.length; j++) {
          var booleans = false
          if (allExhibition.length > 0) {
            for (var q = 0; q < allExhibition.length; q++) {
              if (
                allExhibition[q].exhibitionId ===
                response.data.data[j].exhibitionId
              ) {
                booleans = true
              }
            }
          }
          if (booleans === false) {
            var obj = {
              dates: '',
              list: []
            }
            const date1 = response.data.data[j].openexTime.substring(
              0,
              8
            )
            obj.dates = date1
            obj.list.push(response.data.data[j])
            allExhibition.push(response.data.data[j])
            for (var k = j + 1; k < response.data.data.length; k++) {
              const date2 = response.data.data[k].openexTime.substring(
                0,
                8
              )
              if (
                date1 === date2 &&
                response.data.data[k].exhibitionId !==
                response.data.data[j].exhibitionId
              ) {
                obj.list.push(response.data.data[k])
                allExhibition.push(response.data.data[k])
              }
            }
            exList.push(obj)
          }
          this.exhibitionList = this.sortExhibitionList(exList)
          this.exhibitionListStandby = this.sortExhibitionList(exList)
        }
      })
    },

    getExhibitionStatus(startTime, endTime) {
      const currentDate = new Date()
      currentDate.setHours(0, 0, 0, 0)

      const startDate = new Date(startTime).getTime()
      const endDate = new Date(endTime).getTime()

      if (currentDate >= startDate && currentDate <= endDate) {
        return '进行中'
      }

      if (currentDate < startDate) {
        return '未开始'
      }

      if (currentDate > endDate) {
        return '已结束'
      }
    },

    // 时间戳转换时间
    toDate(string) {
      // var n = number * 1000
      if (!string) return ''
      var date = new Date(string)
      var Y = date.getFullYear()
      var M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return Y + '年' + M + '月' + D + '日'
    },
    isEmptyStr(string) {
      if (string === '' || string === null || string === undefined) {
        return true
      } else {
        return false
      }
    },
    // 校验用户信息完整性
    checkUserInfo() {
      this.$set(this, 'userInfo', JSON.parse(sessionStorage.getItem('user')))
      // debugger
      if (
        // (this.userInfo.channel === 'MOBILE' || this.userInfo.channel === 'EMAIL') &&
        (this.isEmptyStr(this.userInfo.name) || this.isEmptyStr(this.userInfo.email) || this.isEmptyStr(this.userInfo.mobile))
      ) {
        this.userinfo_visible = true
      }
    },
    // 判断是否是第三方登录
    checkIsFrom3rd() {
      if (this.userInfo.refSys !== 'system') {
        this.root.isFrom3rd = true
        this.isFrom3rd = true
        sessionStorage.setItem('isFrom3rd', true)
        this.exhibitionId =
          sessionStorage.getItem('exhibitionId') || this.$route.query.expoid
        this.excompanyType =
          sessionStorage.getItem('excompanyType') ||
          this.$route.query.excompanyType
        sessionStorage.setItem('exhibitionId', this.exhibitionId)
        sessionStorage.setItem('excompanyType', this.excompanyType)
        // 不显示选择展会弹框
        this.exhibitionView = false
        // 不显示切换展会按钮
        this.isShowSwitchExhibition = false
        // 获取展会名称
        this.$http({
          method: 'get',
          url:
            this.api +
            'a/api/home/getExhibiNameById?exhibitionId=' +
            this.exhibitionId
        }).then(response => {
          if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
            this.exhibitionName = response.data.data.exhibitionName
            this.exhibitionNameEn = response.data.data.exhibitionNameEn
            sessionStorage.setItem('exhibitionName', this.exhibitionName)
            sessionStorage.setItem('exhibitionNameEn', this.exhibitionNameEn)
          }
        })
        this.initData()
      } else {
        this.defaultGetQualificationMy()
        this.queryAuthentication().then(() => {
          this.getExhibition()
        })
      }
    },
    // 选择展会
    getExhibition() {
      if (this.$route.query.exhibitionId) {
        this.exhibitionId = this.$route.query.exhibitionId
        sessionStorage.setItem('exhibitionId', this.exhibitionId)
        sessionStorage.setItem('noSwitchExid', true)
        this.isShowSwitchExhibition = false
        // 获取展会名称
        this.$http({
          method: 'get',
          url:
            this.api +
            'a/api/home/getExhibiNameById?exhibitionId=' +
            this.exhibitionId
        })
          .then(response => {
            if ((response.data.resultCode === 0 || response.data.resultCode === '0')) {
              this.exhibitionName = response.data.data.exhibitionName
              this.exhibitionNameEn = response.data.data.exhibitionNameEn || this.exhibitionName
              sessionStorage.setItem('exhibitionName', this.exhibitionName)
              sessionStorage.setItem('exhibitionNameEn', this.exhibitionNameEn)
            }
          })
          .catch(() => {
            this.$message.error('网络出错，请重试')
          })
      } else {
        if (sessionStorage.getItem('exhibitionName')) {
          this.exhibitionView = false
          this.exhibitionId = sessionStorage.getItem('exhibitionId')
          this.exhibitionName = sessionStorage.getItem('exhibitionName')
          this.exhibitionNameEn = sessionStorage.getItem('exhibitionNameEn') || this.exhibitionName
        } else if (this.$route.query.eName) {
          this.exhibitionView = false
          this.exhibitionId = this.$route.query.eId
          this.exhibitionName = this.$route.query.eName
          this.exhibitionNameEn = this.$route.query.exhibitionNameEn || this.exhibitionName
        } else {
          this.exhibitionView = true
          setTimeout(this.selectExhibitionList, 500)
        }
      }
      this.initData()
    },
    initData() {
      this.offset = 0 // 展会时间安排偏移量
      this.activeTimeBox = null // 当前展会属于哪个期间
      this.maxBox = 5 // 页面中显示的展会时间安排盒子数
      this.fileDataIdList = [] // 选中下载的资料清空
      this.popNoticeIndex = 0 // 重要弹窗
      this.popNotices = [] // 重要弹窗队列

      // banner图
      this.getBanner()
      // 公告
      this.getNotice()
      // 开展时间
      this.getEventTimes()
      // 主场人员
      this.getContactInfos()
      // 资料下载
      this.getManualFiles()
      // 自助服务--审图、租赁、固定费用...
      if (!this.root.isLogin || this.isFrom3rd) {
        // 没有登录或者是第三方登录直接获取功能服务
        this.getServices()
      } else {
        // 获取所有的展位，有光地就传光地，没有就传标摊
        this.boothInfoList()
      }
    },
    handleScroll() {
      // 距离顶部的距离
      const offsetTop = 60
      const scrollTop = window.pageYOffset
      const doc = document.querySelector('.new-mian-ui-exhibition')
      if (scrollTop < offsetTop) {
        doc.style.top = offsetTop - scrollTop + 'px'
      } else {
        doc.style.top = 0
      }
    },
    boothInfoList() {
      this.$http({
        method: 'get',
        url: `${this.api}a/api/booth/boothInfoList?exhibitionId=${this.exhibitionId
        }`
      })
        .then(res => {
          if (res.data.resultCode === 0 || res.data.resultCode === '0') {
            this.booths = res.data.data
            const special_booth = []
            const normal_booth = []
            this.booths.map(booth => {
              if (booth.type === '2') {
                // 光地
                special_booth.push(booth)
              } else if (booth.type === '1') {
                // 标摊
                normal_booth.push(booth)
              }
            })
            if (normal_booth.length > 0) {
              this.excompanyType = 1
            }
            // 有光地优先使用光地传值，后面的赋值覆盖前面的赋值
            if (special_booth.length > 0) {
              this.excompanyType = 2
            }
            // 有光地有标摊取全部，后面的赋值覆盖前面的赋值
            if (normal_booth.length > 0 && special_booth.length > 0) {
              this.excompanyType = null
            }
            this.excompanyType = null
            this.getServices()
          } else {
            this.getServices()
          }
        })
        .catch(() => {
          this.getServices()
        })
    },
    initConfig() {
      this.initFeedbackUrl()
    },
    initFeedbackUrl() {
      this.$http({
        methods: 'get',
        url: `${this.api}a/api/config/getSysConfigByKey?key=ems.index.feedback.url`
      }).then(res => {
        if ((res.data.resultCode === 0 || res.data.resultCode === '0') && res.data.data.length > 0) {
          this.feedbackUrl =
            (res.data.data && res.data.data[0].value) ||
            'https://support.qq.com/products/297738'
        }
      })
    },
    changePagination(page) {
      this.specialPage.current = page
      // this.getTableData()
      this.getExhibitionPageData()
    },
    /** 打开 申请成为特装搭建商 弹框 */
    openApplySpecial() {
      if (JSON.stringify(this.userCompanyInfo) === '{}') {
        this.queryAuthentication().then(() => {
          this.specialVisible = true
          this.getExhibitionPageData()
        })
        return false
      }
      this.specialVisible = true
      this.getExhibitionPageData()
    },
    resetSearch() {
      this.specialPage.current = 1
      this.specialForm.exhibitionName = ''
      // this.getTableData()
      this.getExhibitionPageData()
    },
    /** 获取用户认证信息 */
    queryAuthentication() { // 认证查询
      console.log('获取用户认证信息')
      return new Promise((resolve) => {
        this.$http.get(`${this.HallApi}api/hall/rest/qualification/my`).then(res => {
          if (res.data && Object.keys(res.data).length > 0) {
            if (res.data.status === 'IN_REVIEW') {
              this.showConfirm('企业认证已提交，但在审核中，请耐心等待审核结果。', '/personalCenter?type=enterprise', '查看')
              return
            } else if (res.data.status === 'REJECT') {
              this.showConfirm('企业认证不通过，请至我的企业查看审核结果。', '/personalCenter?type=enterprise', '查看')
              return
            } else if (res.data.remark === 'PENDING') {
              if (res.data.auditTag === 1) {
                this.showConfirm(['加入企业申请已提交，请联系公司企业管理员审核,', '可至 “我的企业/我的申请” 查看审核结果。'], '/personalCenter?type=enterprise', '查看', true)
                return
              } else {
                this.showConfirm(['加入企业申请不通过，', '请至 “我的企业/我的申请” 重新申请。'], '/personalCenter?type=enterprise', '去申请')
                return
              }
            } else if (res.data.status === 'PASS') {
              this.userCompanyInfo = res.data
              this.showApplyBtn = true
              resolve()
            } else {
              this.showConfirm('请先完成企业认证', '/EnterpriseCertification', '企业认证', '去完成')
              return
            }
          } else {
            this.showConfirm('请先完成企业认证', '/EnterpriseCertification', '企业认证', '去完成')
            return
          }
        }).catch(e => {
          if (e.response.status === 400) {
            this.showConfirm('请先完成企业认证', '/EnterpriseCertification', '企业认证', '去完成')
            return
          }
        })
      })
    },

    /** 获取展会分页数据 */
    getExhibitionPageData() {
      this.$http.post(`${this.api}api/user/exhibition/exhibition/page`, {
        pageNo: this.specialPage.current,
        pageSize: this.specialPage.size,
        exhibitionName: this.specialForm.exhibitionName
      }).then(res => {
        const responseData = res.data.data
        this.specialTableData = responseData.list
        this.specialTotal = responseData.total
      })
    },

    /** 申请加入 */
    apply(scope) {
      this.applyCurrentExhibition = {
        ...scope
      }
      this.applyVisible = true
      this.special_form.resetFields()
    },
    /** 提交申请 */
    submitApply(e) {
      e.preventDefault()
      this.special_form.validateFields((err, values) => {
        if (err) {
          return
        }
        const user = JSON.parse(sessionStorage.getItem('user'))
        const params = {
          ...values,
          exhibitionId: this.applyCurrentExhibition.exhibitionId,
          exhibitionName: this.applyCurrentExhibition.exhibitionName,
          contractor: this.userCompanyInfo.companyName,
          sponsor: this.applyCurrentExhibition.sponsor,
          agencyId: this.applyCurrentExhibition.agencyId,
          companyId: this.userCompanyInfo.companyId,
          userId: user.id
        }
        /* 重新提交 */
        if (this.applyCurrentExhibition.status === '3') {
          this.$http.put(`${this.api}api/user/exhibition/audit`, {
            ...params,
            status: '1',
            id: this.applyCurrentExhibition.id
          }).then(res => {
            if (res.data.resultCode === 0) {
              this.applyVisible = false
              this.$message.success('重新申请成功!')
              this.applyCurrentExhibition = {}
              this.special_form.resetFields()
              return
            }
            this.$message.error(res.data.message)
          })
          return false
        }

        this.$http.post(`${this.api}api/user/exhibition/create`, params).then(res => {
          if (res.data.resultCode === 0) {
            this.$message.success(res.data.message)
            this.applyVisible = false
            this.applyCurrentExhibition = {}
            this.special_form.resetFields()
            return
          }

          this.$message.error(res.data.message)
        })
      })
    },
    /** 查看我的申请 */
    viewApply(scope) {
      this.currentMyApplyOp = scope
      this.getMyApplyPageData().then(() => {
        this.myApplyVisible = true
      })
    },
    reapply(scope) {
      console.log(scope)
      const { remark,
        email,
        mobilePhone,
        contact,
        exhibitor,
        boothNum } = scope
      this.myApplyVisible = false
      this.applyVisible = true
      this.applyCurrentExhibition = { ...scope }

      this.$nextTick(() => {
        this.special_form.setFieldsValue({
          remark,
          email,
          mobilePhone,
          contact,
          exhibitor,
          boothNum
        })
      })
    },
    changeMyApplyPagination(page) {
      this.myApplyPage.current = page
      this.getMyApplyPageData()
    },
    getMyApplyPageData() {
      return new Promise((resolve) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        this.$http.post(`${this.api}api/user/exhibition/page`, {
          page: {
            size: this.myApplyPage.size,
            current: this.myApplyPage.current
          },
          exhibitionId: this.currentMyApplyOp.exhibitionId,
          userId: user.id
        }).then(res => {
          const responseData = res.data.data
          this.myApplyTableData = responseData.list
          this.myApplyTotal = responseData.total
          resolve()
        })
      })
    },
    // 先特殊处理请求获取认证信息一次
    defaultGetQualificationMy() {
      this.$http.get(`${this.HallApi}api/hall/rest/qualification/my`)
    }
  }

}
</script>
<style scoped>
@import "../../assets/css/common.css";
@import "../../assets/css/main.css";
.exhibition-bodys-center-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
}

.exhibition-bodys-center-time {
  display: flex;
  gap: 20px;
  align-items: center;
  max-width: 100%;
  flex-wrap: nowrap;
  color: #000;

  .time {
    color: #666;
  }

  .area {
    width: 300px;
    white-space: nowrap; /* 禁止换行 */
    overflow: hidden; /* 隐藏超出容器的内容 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }
}

.exhibition-status-tag {
  color: #fff;
  background: #d10100;
  height: 24px;
  box-sizing: border-box;
  margin-right: 4px;
  border-radius: 6px;
  padding:2px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.time-roll {
  overflow: auto;
}
.time-roll::-webkit-scrollbar {
  width: 8px;
  height: 4px;
}
.time-roll::-webkit-scrollbar-track {
  background-color: #fff;
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
}
.time-roll::-webkit-scrollbar-thumb {
  background-color: #e0e3e6;
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
}
.red-block {
  position: absolute;
  height: 2px;
  width: 40px;
  background: white;
  top: 58px;
  left: 20px;
}
.swiper-slide-remake {
  width: 39.8px !important;
}
.Vertical {
  left: 49%;
  position: absolute;
  height: 100%;
  width: 1px;
  background: #cccccc;
}
.contactCard {
  width: 265px;
  display: inline-block;
}
.contactStyle {
  position: absolute;
  transition: left 1s;
  left: 0px;
}
.moveContact {
  position: absolute;
  top: 28%;
  font-size: 45px;
  cursor: pointer;
}
.moveDis {
  color: #cccccc;
  cursor: not-allowed;
}
#moveLeft {
}
#moveRight {
  right: 0px;
}
.notice-inner-text p {
  white-space: inherit !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
}
.notice-inner-text span {
  white-space: inherit !important;
}
.login-div {
  margin-top: 80px;
  width: 150px;
  margin-left: 50px;
}
.service {
  width: 169.5px;
  display: inline-block;
  text-align: center;
}
.serviceImg {
  display: inline-block;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
@red: #d10100;
.new-mian-ui {
  margin-bottom: 80px;
  background: #fff;
  .flex {
    display: flex;
  }
  .click {
    &:hover {
      color: @red;
      cursor: pointer;
    }
  }
  .verticalLine:before {
    content: "";
    display: inline-block;
    width: 2px;
    height: 18px;
    margin-right: 10px;
    background: @red;
    align-self: center;
    vertical-align: middle;
  }
  .txtOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &-exhibition {
    position: fixed;
    left: 0;
    top: 60px;
    width: 100%;
    height: 36px;
    background: #f2f2f2;
    z-index: 999;
    &-box {
      text-align: center;
      margin: 0 auto;
      height: 36px;
      line-height: 36px;
      &-exhibitionName {
        margin-right: 30px;
        color: #222;
        font-size: 14px;
      }
      &-btn {
        color: #666;
        font-size: 14px;
      }
    }
  }
  .banners {
    margin-top: 56px;
  }

  &-contain {
    & > div {
      margin-top: 50px;
      background: #fff;
    }
    & > div:first-child {
      margin-top: 20px;
    }
    &-notice {
      width: 100%;
      height: 40px;
      border: 1px solid rgba(224, 226, 230, 1);
      border-radius: 20px;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      line-height: 20px;
      &-icon {
        width: 100px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
      &-con {
        width: 800px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #222;
        &-carousel {
          text-align: left;
          height: 18px;
          line-height: 18px;
          color: #222;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-more {
        width: 100px;
        text-align: right;
      }
    }
    &-server {
      display: flex;
      flex-wrap: wrap;
      &-box {
        width: 275px;
        height: 120px;
        padding: 20px;
        &:hover {
          box-shadow: 0px 2px 8px 0px rgba(187, 187, 187, 0.6);
          div {
            color: @red;
          }
        }
        img {
          width: 50px;
          align-self: center;
        }
        &-rightBox {
          margin-left: 20px;
          height: 80px;
          &-title {
            font-size: 16px;
            color: #222222;
            height: 40px;
            line-height: 40px;
            &.enStyle {
              font-size: 14px;
            }
          }
          &-dec {
            height: 40px;
            font-size: 14px;
            color: #666666;
            &.enStyle {
              font-size: 12px;
            }
          }
        }
      }
    }
    &-exTime {
      width: 100%;
      &-title {
        @size: 18px;
        width: 100%;
        height: @size;
        font-size: @size;
        line-height: @size;
        font-weight: bold;
        margin-bottom: 36px;
        color: #222;
      }
      &-showBox {
        height: 150px;
        .arrow {
          border: none;
          align-self: center;
          font-size: 30px;
          &.disabled {
            color: #ddd;
            &:hover {
              cursor: not-allowed;
              color: #ddd;
            }
          }
        }
        &-leftArrow {
          margin-right: 20px;
        }
        &-rightArrow {
          margin-left: 20px;
        }
        &-containBox {
          width: 1040px;
          overflow: hidden;
          &-translateBox {
            &-detailBox {
              color: #222;
              width: 200px;
              height: 150px;
              margin-right: 10px;
              border: 1px solid #e0e2e6;
              overflow: hidden;
              text-align: center;
              &.active {
                border-color: #d10100;
                &.active > :first-child {
                  border-color: #d10100;
                  background: #ffeeee;
                  font-weight: bold;
                  font-size: 16px;
                  color: #222;
                }
              }
              &-title {
                width: 190px;
                height: 49px;
                line-height: 49px;
                padding: 0 5px;
                border-bottom: 1px solid #e0e2e6;
                font-size: 16px;
              }
              &-con {
                height: 100px;
                padding: 30px 0;
                color: #666;
                text-align: center;
                & > div {
                  &.txtLeft {
                    padding-left: 15px;
                    text-align: left;
                  }
                }
              }
            }
          }
        }
      }
      &-noData {
        font-size: 16px;
        color: #222;
        text-align: center;
        padding: 20px 0;
      }
    }
    &-contacts {
      &-title {
        @size: 18px;
        width: 100%;
        height: @size;
        font-size: @size;
        line-height: @size;
        font-weight: bold;
        margin-bottom: 36px;
        color: #222;
      }
      &-contain {
        width: 100%;
        padding: 0 10px;
        flex-wrap: wrap;
        &-box {
          width: 240px;
          height: 280px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 8px 0px rgba(187, 187, 187, 0.6);
          margin-right: 40px;
          margin-bottom: 30px;
          padding: 30px 20px;
          &:nth-child(4n) {
            margin-right: 0;
          }
          &-title {
            color: #222;
            font-size: 16px;
            margin-bottom: 20px;
          }
          &-subTitle {
            color: #666;
            font-size: 14px;
            margin-bottom: 30px;
          }
          &-Contacts {
            width: 100%;
            height: 120px;
            padding: 20px;
            background: rgba(246, 246, 246, 1);
            &-telephone {
              word-wrap: break-word;
            }
            &-name {
              font-size: 14px;
              font-weight: 400;
              color: rgba(34, 34, 34, 1);
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    &-download {
      @downloadColor: #e0e2e6;
      &-title {
        @size: 18px;
        width: 100%;
        height: @size;
        font-size: @size;
        line-height: @size;
        font-weight: bold;
        margin-bottom: 36px;
        color: #222;
      }
      &-contain {
        width: 100%;
        padding: 30px;
        border: 1px solid @downloadColor;
        &-list {
          width: 100%;
          position: relative;
          flex-wrap: wrap;
          &.downloadvVerticalLine::after {
            content: "";
            position: absolute;
            width: 2px;
            background: @downloadColor;
            height: 100%;
            top: 0;
            left: 514px;
          }
          &-item {
            width: 485px;
            padding-bottom: 12px;
            margin-bottom: 12px;
            font-size: 14px;
            color: #333;
            margin-right: 60px;
            border-bottom: 1px solid @downloadColor;
            &:nth-child(2n) {
              margin-right: 0;
            }
          }
        }
        &-downloadBtn {
          margin-top: 30px;
          text-align: right;
        }
      }
      &-noFile {
        border: 1px solid @downloadColor;
        width: 100%;
        padding: 30px 0;
        text-align: center;
        img {
          width: 120px;
          height: 120px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .floatview {
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.popNotice-time {
  text-align: right;
  margin-top: 30px;
  color: rgba(102, 102, 102, 1);
}
.exhibition-bodys {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0 20px;
  &-left {
    width: 60px;
    height: 60px;
    border: 1px solid #edf0f4;
    padding: 5px;
    &-img {
      width: 100%;
      height: 100%;
    }
  }
  &-center {
    width: 80%;
    &-title {
      height: 40px;
      line-height: 20px;
      font-size: 16px;
      color: #222;
    }
    &-time {
      color: #666;
    }
  }
}
.center{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
  }
.dxModal{
  background-color: #e8e8eb;
  padding: 10px;
  margin-top: 30px;
  .title{
    font-size: 20px;
    padding:20px 0;
    color: #000;
  }
  .flex{
    display: flex;
    align-items: center;
    p{
      line-height: 30px;
    }
    img{
      width:250px
    }
  }
}
.footer{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.exhibition-opera {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tip-text {
    color: #d10100;
    font-size: 14px;
  }
}

.special-form {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/main.vue